var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    enableBackground: "new 0 0 80 80",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M40,18.072c-20.558,0-36.664,8.725-36.664,19.859S19.442,57.791,40,57.791s36.663-8.725,36.663-19.859 S60.558,18.072,40,18.072z M36.193,24.183h4.004l-1.271,6.11H42.5c2.268,0,3.789,0.316,4.654,1.11 c0.848,0.782,1.104,2.065,0.765,3.813l-1.587,7.298h-4.07l1.462-6.749c0.179-0.925,0.108-1.569-0.202-1.909 c-0.311-0.341-0.992-0.508-2.012-0.508h-3.205l-1.934,9.166h-4.01L36.193,24.183z M18.613,30.293h8.146 c3.885,0,6.236,2.602,5.317,6.487c-1.068,4.511-3.933,5.734-9.196,5.734h-2.518l-0.799,4.583h-4.046L18.613,30.293z M50.693,30.293 h8.146c3.885,0,6.236,2.602,5.317,6.487c-1.068,4.511-3.933,5.734-9.196,5.734h-2.519l-0.799,4.583h-4.047L50.693,30.293z  M22.08,33.349l-1.152,6.11h2.614c2.262,0,4.362-0.256,4.714-3.628c0.131-1.307-0.412-2.482-3.025-2.482H22.08z M54.16,33.349 l-1.151,6.11h2.614c2.261,0,4.362-0.256,4.713-3.628c0.132-1.307-0.411-2.482-3.024-2.482H54.16z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.63737804ea6b98b448a19f62c3f504cc.svg";
export { ForwardRef as ReactComponent };